export enum UserListLinkRel {
	USER_LIST = 'schirUserList',
	USER_PROFILE = 'profile',
}
